import styled from "styled-components/macro";
/* istanbul ignore next */
export const LoaderWrapper = styled.div`
  width: ${(props): string => props.theme.spacing(9)};
`;
